import { FC } from "react";

import { Box, Grid, Typography } from "@mui/material";

import { IUserData } from "../../interface/IDocument";

interface Props {
  detailPatient?: IUserData | null;
}

export const NutritionalPage: FC<Props> = ({ detailPatient }) => {
  return (
    <Grid container mt={5}>
      <Box>
        <Grid container item xs={12} sm={11} mb={6}>
          {detailPatient?.userTypeform ? (
            <>
              <Grid item xs={12} sm={12}>
                <Typography variant="h5" component="h5" fontWeight={600} mb={1}>
                  Allgemeine Daten
                </Typography>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography variant="subtitle2">Startgewicht</Typography>
              </Grid>
              <Grid item xs={12} sm={9}>
                <Typography variant="subtitle2" fontWeight={600}>
                  {detailPatient?.userTypeform?.initialWeight} Kg
                </Typography>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography variant="subtitle2">Endgewicht</Typography>
              </Grid>
              <Grid item xs={12} sm={9}>
                <Typography variant="subtitle2" fontWeight={600}>
                  120 kg
                </Typography>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography variant="subtitle2">Körpergröße</Typography>
              </Grid>
              <Grid item xs={12} sm={9}>
                <Typography variant="subtitle2" fontWeight={600}>
                  {detailPatient?.userTypeform?.height} cm
                </Typography>
              </Grid>
            </>
          ) : (
            <Grid item xs={12} sm={12} mb={15}>
              <Typography variant="h5" component="h5" fontWeight={600} mb={1}>
                Allgemeine Daten
              </Typography>
              <Typography color="red">
                Keine relevanten Informationen verfügbar
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>
    </Grid>
  );
};
